import { EnumEventName, EventServerError } from '@calm/evexia-analytics';
import { CustomAxiosError } from '@calm/evexia-web-sdk/generated/lib/additional-types';
import { Environment } from '@rhg/constants';
import { extractAppConfig } from '@rhg/hooks/use-app-config';
import { logger } from '@rhg/libs/logger';
import { createDestinations } from '../destination';
import mapBaseEventProps from '../map-base-event-props';

const {
    NEXT_PUBLIC_ENV: env,
    NEXT_PUBLIC_ANALYTICS_DEBUG: debug,
    NEXT_PUBLIC_AMPLITUDE_TOKEN: amplitudeToken,
    NEXT_PUBLIC_AMPLITUDE_BASEURL: amplitudeBaseUrl,
} = extractAppConfig();

const destinations = createDestinations({
    amplitudeToken,
    amplitudeBaseUrl,
    env: env as Environment,
    debug,
});

export const trackAxiosError = (error: CustomAxiosError) => {
    const config = error?.config;
    const errorCode = error?.response?.status;
    const method = config?.method;
    const urlPattern = config?._metadata?.urlPattern;
    const sdkMethod = config?._metadata?.sdkMethod;
    const traceParent = config?.headers?.traceparent;
    const baseUrl = config?.baseURL;
    const url = config?.url?.replace(baseUrl ?? '', '');
    const description = error?.message;
    if (!traceParent) {
        logger.warn(`No traceparent header for ${url}`);
    }

    try {
        const payload: EventServerError = {
            traceparent: traceParent! as string,
            URLPattern: `${method?.toLocaleUpperCase()}:${urlPattern}`,
            ErrorCode: errorCode!,
            Description: description,
            SDKMethod: sdkMethod,
            IS_SCREEN_VIEW: false,
        };

        if (errorCode !== 404) {
            const mappedPayload = mapBaseEventProps(payload);
            destinations.forEach((destination) => {
                if (destination.isLoaded()) {
                    destination.track(EnumEventName.ServerError, mappedPayload);
                }
            });
            logger.warn('ServerError', { ...mappedPayload });
        }
    } catch (err) {
        logger.error('Failed to track ServerError', {}, err as Error);
    }
};

export default trackAxiosError;
